import Vue from 'vue'
import Router from 'vue-router'
import {summary_router} from './summary/router/index.js'
import {member_router} from './member/router/index.js'
import {agent_router} from './agent/router/index.js'
import {web_router} from './web/router/index.js'
import {nweb_router} from './nweb/router/index.js'
import {wap_router} from './wap/router/index.js'
import {warrantLogin} from './wap/assets/js/login'
import {getData, postData} from "./agent/assets/js/httpRequest";
import axios from 'axios';
import QS from 'qs';
import Cookies from 'js-cookie';

Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

var router_arr = [{
    path: '/',
    name: '/',//作品列表
    redirect: '/member',
}];
router_arr.push(...summary_router);
router_arr.push(...member_router);
router_arr.push(...agent_router);
router_arr.push(...web_router);
router_arr.push(...nweb_router);
router_arr.push(...wap_router);

router_arr.push({//设置404跳转
    path: "*",
    redirect: "/"
})

let route_count = new Router({
    routes: router_arr,
    mode: 'history',
})

route_count.beforeEach((to, from, next) => {
    //根据mate更改mate
    if (to.meta.content) {
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        meta.content = to.meta.content;
        meta.name = to.meta.name;
        head[0].appendChild(meta)
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        if (!localStorage.getItem("icoytitle") || localStorage.getItem("icoytitle") === '' || to.path.indexOf('/member') != 0) {
            if (to.path.indexOf('/wap/database') != -1) {
                document.title = to.meta.title
            } else if (to.path.indexOf('/mycenter') != 0) {
                document.title = to.meta.title + '-大像元景';
            } else {
                document.title = to.meta.title + '-大像元景';
            }
        } else {
            document.title = to.meta.title + '-' + localStorage.getItem("icoytitle");
        }
    } else {
        document.title = '大像元景'
    }
    //判断参数中的s属性
    if (to.query.s == '/member/work/work') {
        next('/member/work');
    }
    if (to.query.s == '/agent/login/index') {
        next('/agent/login');
    }
    if (to.query.s == '/agdinfipklmmin/login/index') {
        next('/summary/partner');
    }


    //获取用户权限信息，为空即没登录，跳转至登录页

    if (to.path.indexOf('/agent') == 0) {
        if (to.path === '/agent/login') {
            //允许登录
            next();
        } else {
            //这里判断是否登录，如果登录则传入true，如果未登录则传入false
            if (true) {
                next();
            } else {
                //未登录则跳到登录
                next('/agent/login');
            }
        }
    }

    if (to.path.indexOf('/summary') == 0) {
        if (to.path === '/summary/login') {
            //允许登录
            next();
        } else {
            //这里判断是否登录，如果登录则传入true，如果未登录则传入false
            if (true) {
                next();
            } else {
                //未登录则跳到登录
                next('/summary/login');
            }
        }
    }

    if (to.path.indexOf('/member') == 0) {
        if (to.path === '/member/login' || to.path === '/member/register' || to.path === '/member/password' || to.path === '/member/live/bindmanager') {
            //允许登录
            next();
        } else {
            //这里判断一下是不是token变更的跳转
            if (to.redirectedFrom && to.redirectedFrom.indexOf("/member/work/token/") != -1) {
                let token_arr = to.redirectedFrom.split("/");
                let token = token_arr[token_arr.indexOf("token") + 1];
                let user = token_arr[token_arr.indexOf("user") + 1];
                if (!user || user == '') {
                    next('/member/login');
                } else {
                    //调用获取信息接口,并跳转work界面
                    localStorage.setItem("member-token", token);
                    localStorage.setItem("user-mark-token", user);

                    axios.defaults.baseURL = '/api'
                    axios.defaults.headers.common["member-token"] = localStorage.getItem("member-token");
                    if (Cookies.get("member-token")) {
                        axios.defaults.headers.common["member-token"] = Cookies.get("member-token");
                    }
                    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
                    axios.defaults.headers.common["user-host"] = location.host;
                    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
                    return new Promise((resolve, reject) => {
                        axios.post('/member/work/api_copyrights', {})
                            .then(res => {
                                if (res.data.data) {
                                    localStorage.setItem(
                                        "icoytitle",
                                        res.data.data.isco["title"]
                                    );
                                    localStorage.setItem(
                                        "icoylogo",
                                        res.data.data.isco["logo"]
                                    );
                                    localStorage.setItem(
                                        "icoycopyright",
                                        res.data.data.isco["copyright"]
                                    );

                                    next('/member/work');
                                } else {
                                    next('/member/work');
                                }
                                resolve(res);
                            })
                            .catch(err => {
                                reject(err)
                            })
                    });


                }
            }

            //这里判断下是否是首页
            if (to.path == '/member') {
                if (location.pathname == "/member/login") {
                    next();
                } else {
                    axios.defaults.baseURL = '/api'
                    axios.defaults.headers.common["member-token"] = localStorage.getItem("member-token");
                    if (Cookies.get("member-token")) {
                        axios.defaults.headers.common["member-token"] = Cookies.get("member-token");
                    }
                    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
                    axios.defaults.headers.common["user-host"] = location.host;
                    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
                    return new Promise((resolve, reject) => {
                        axios.post('/member/rule/getRullm', {})
                            .then(res => {
                                if (res.data.data) {
                                    next();
                                } else {
                                    next('/member/login');
                                }
                                resolve(res);
                            })
                            .catch(err => {
                                reject(err)
                            })
                    });

                    // postData('/member/rule/getRullm', {}).then(res => {
                    // if (res.data.data) {
                    //     next();
                    // }else{
                    //     next('/member/login');
                    // }
                    // });
                }
                return;
            } else {
                next();
            }
        }
    }
    if (to.path.indexOf('/wap') == 0) {
        if (to.path == '/wap/mycenter/myCard/writeOffCard' || to.path == '/wap/mycenter/myOrder/Writeoff' || to.path == '/wap/mycenter/myPrize/prizeDetails'
            || to.path.indexOf('/wap/mycenter/money') != -1 || to.path.indexOf('/wap/mycenter/myIndent/writeOffCard') != -1 || to.path.indexOf('/wap/database') != -1) {
            console.log('不用登陆');
        } else {

            if (to.query.member_id) {
                localStorage.setItem("member-id", to.query.member_id);
            }
            warrantLogin(function (data) {
                if (data.status == 0) {
                    //验证登陆
                    if (to.path === '/wap/login') {
                        //允许登录
                        next();
                    } else {
                        //这里判断是否登录，如果登录则传入true，如果未登录则传入false
                        if (true) {
                            next();
                        } else {
                            //未登录则跳到登录
                            next('/agent/login');
                        }
                    }
                }
            });
            return;
        }
        // if (to.query.user_token) {
        //     localStorage.setItem("user-token", to.query.user_token);
        // }
        if (to.query.member_id) {
            localStorage.setItem("member-id", to.query.member_id);
        }
        //验证登陆
        if (to.path === '/wap/login') {
            //允许登录
            next();
        } else {
            //这里判断是否登录，如果登录则传入true，如果未登录则传入false
            if (true) {
                next();
            } else {
                //未登录则跳到登录
                next('/agent/login');
            }
        }
    }
    if (to.path.indexOf('/web') == 0) {
        if (to.query.member_id) {
            localStorage.setItem("web-member-id", to.query.member_id);
            // localStorage.setItem("web-style-id", to.query.style_id);
        }
    }
    if (to.path.indexOf('/nweb') == 0) {
        if (to.query.agent_id) {
            localStorage.setItem("web-agent-id", to.query.agent_id);
        }
    }
    //跳转到404
    next();
});

export default route_count;



// WEBPACK FOOTER //
// ./src/router.js